import { render } from "./App.vue?vue&type=template&id=3bc7e0e4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3bc7e0e4&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__